export default "__VITE_ASSET__CbS5KuiP__"